import { render, staticRenderFns } from "./v-inlinealerts.vue?vue&type=template&id=4d47b3dc&scoped=true&"
import script from "./v-inlinealerts.vue?vue&type=script&lang=js&"
export * from "./v-inlinealerts.vue?vue&type=script&lang=js&"
import style0 from "./v-inlinealerts.vue?vue&type=style&index=0&id=4d47b3dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d47b3dc",
  null
  
)

export default component.exports